(() => {
  'use strict';
  const root = document.querySelector('.cr-case-library');
  if (!root) return;
  const projects = [...root.querySelectorAll('[data-project]')];
  const query = root.querySelector('#cr-case-query');
  const topic = root.querySelector('#cr-case-topic');
  const count = root.querySelector('[data-case-count]');
  const empty = root.querySelector('[data-case-empty]');
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const normalise = text => text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
  const records = projects.map(element => ({ element, groups: element.dataset.groups.split(' '), text: normalise(element.querySelector('summary').textContent + ' ' + element.querySelector('.cr-project-story').textContent) }));
  function filter() {
    const terms = normalise(query.value.trim()).split(/\s+/).filter(Boolean);
    let matches = 0;
    records.forEach(record => {
      const visible = (!topic.value || record.groups.includes(topic.value)) && terms.every(term => record.text.includes(term));
      record.element.hidden = !visible;
      if (visible) matches++;
    });
    count.textContent = `${matches} of ${projects.length} case studies`;
    empty.hidden = matches !== 0;
  }
  function reset() { query.value = ''; topic.value = ''; filter(); }
  root.querySelector('[data-case-tools]').hidden = false;
  query.addEventListener('input', filter);
  topic.addEventListener('change', filter);
  root.querySelectorAll('[data-case-reset]').forEach(button => button.addEventListener('click', () => { reset(); query.focus(); }));
  function openLinkedCase() {
    const selected = projects.find(project => '#' + project.id === location.hash);
    if (!selected) return;
    reset();
    selected.open = true;
    requestAnimationFrame(() => selected.scrollIntoView({ block: 'start', behavior: 'instant' }));
  }
  projects.forEach(project => {
    project.addEventListener('toggle', event => {
      if (event.target !== project) return;
      if (project.open) history.replaceState(null, '', '#' + project.id);
      else if (location.hash === '#' + project.id) history.replaceState(null, '', location.pathname + location.search);
    });
    project.querySelector('[data-close-project]').addEventListener('click', () => {
      project.open = false;
      project.querySelector('summary').focus({ preventScroll: true });
      project.scrollIntoView({ block: 'start', behavior: reduceMotion.matches ? 'instant' : 'smooth' });
    });
    project.querySelector('[data-project-permalink]').addEventListener('click', () => {
      history.replaceState(null, '', '#' + project.id);
    });
  });
  window.addEventListener('hashchange', openLinkedCase);
  filter();
  openLinkedCase();
})();
